import { adToBs, formatBsDate } from './bs'

/** tenant_settings.date_display: how dates are shown (not the fiscal year). */
export type DateDisplay = 'bs' | 'ad' | 'both'

/**
 * "2025-09-27" (ad), "11 Asoj 2082" (bs) or "2025-09-27 · 11 Asoj 2082" (both).
 * Dates outside the BS table fall back to the AD date.
 */
export function formatDisplayDate(iso: string, display: DateDisplay): string {
  const day = iso.slice(0, 10)
  if (display === 'ad') return day
  let bs: string
  try {
    bs = formatBsDate(adToBs(day), 'en')
  } catch {
    return day
  }
  return display === 'bs' ? bs : `${day} · ${bs}`
}

/** Printed bills and the public invoice page always keep the Nepali date. */
export function printDisplay(display: DateDisplay): DateDisplay {
  return display === 'bs' ? 'bs' : 'both'
}
